import { render, staticRenderFns } from "./RealtimeKpiStrip.vue?vue&type=template&id=196fa0ad&scoped=true"
import script from "./RealtimeKpiStrip.vue?vue&type=script&lang=js"
export * from "./RealtimeKpiStrip.vue?vue&type=script&lang=js"
import style0 from "./RealtimeKpiStrip.vue?vue&type=style&index=0&id=196fa0ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fa0ad",
  null
  
)

export default component.exports